import React from "react";
// import { useTranslation } from "react-i18next";
import OrnamentDotted from "../../../assets/images/2026/general/ornament-dotted.png";
import TextPricingTitle from "../../../assets/images/2026/general/text-pricing-title.png";
// import PricingCard5k from "../../../assets/images/2026/general/pricing-card-5k.png";
// import PricingCard10k from "../../../assets/images/2026/general/pricing-card-10k.png";
import Text5kKategori from "../../../assets/images/2026/general/5k.png";
import Text5kUmumPelajar from "../../../assets/images/2026/general/5k-umum-pelajar.png";
import Text10kKategori from "../../../assets/images/2026/general/10k.png";
import Text10kUmumTniPolri from "../../../assets/images/2026/general/10k-umum-tni-polri.png";
import LogoAdaro from "../../../assets/images/2026/general/new_sponsor/ADARO.png";
import LogoAntam from "../../../assets/images/2026/general/new_sponsor/ANTAM.png";
import LogoBRI from "../../../assets/images/2026/general/new_sponsor/BRI.png";
import LogoBukitAsam from "../../../assets/images/2026/general/new_sponsor/BUKIT ASAM.png";
import LogoFreeport from "../../../assets/images/2026/general/new_sponsor/FREEPORT.png";
import LogoGarudaIndonesia from "../../../assets/images/2026/general/new_sponsor/GARUDA INDONESIA.png";
import LogoMindId from "../../../assets/images/2026/general/new_sponsor/MIND ID.PNG";
import LogoPegadaian from "../../../assets/images/2026/general/new_sponsor/PEGADAIAN.png";
import LogoPelindo from "../../../assets/images/2026/general/new_sponsor/PELINDO.png";
import LogoPertamina from "../../../assets/images/2026/general/new_sponsor/PERTAMINA.png";
import LogoPLN from "../../../assets/images/2026/general/new_sponsor/PLN.png";
import LogoTimah from "../../../assets/images/2026/general/new_sponsor/PT TIMAH.png";
import LogoSidoMuncul from "../../../assets/images/2026/general/new_sponsor/SIDO MUNCUL.png";
// import TextHadiahUtama from "../../../assets/images/2026/general/hadiah-utama.png";
// import TextTotalHadiah300 from "../../../assets/images/2026/general/total-hadiah.png";
// import GambarHadiahUtama from "../../../assets/images/2026/general/hadiah-pc.png";
// import TextKategoriNew from "../../../assets/images/2026/general/kategori.png";

const sponsors = [
    { name: "BRI", logo: LogoBRI },
    { name: "Pertamina", logo: LogoPertamina },
    { name: "Freeport Indonesia", logo: LogoFreeport },
    { name: "MIND ID", logo: LogoMindId },
    { name: "PLN", logo: LogoPLN },
    { name: "Adaro", logo: LogoAdaro },
    { name: "ANTAM", logo: LogoAntam },
    { name: "Bukit Asam", logo: LogoBukitAsam },
    { name: "Garuda Indonesia", logo: LogoGarudaIndonesia },
    { name: "Pegadaian", logo: LogoPegadaian },
    { name: "Pelindo", logo: LogoPelindo },
    { name: "PT TIMAH", logo: LogoTimah },
    { name: "Sido Muncul", logo: LogoSidoMuncul },
];

export default function PricingSection() {
    // const { t } = useTranslation();
    return (
        <div className="w-full min-h-fit relative pb-0">
            <div className="flex flex-col items-center relative">
                <div id="pricing-title-section" className="relative w-full">
                    {/* OrnamentDotted - spans full width, repeats on x-axis */}
                    <div
                        className="w-full h-[80px] md:h-[120px] absolute top-0 left-0 z-10"
                        style={{
                            backgroundImage: `url(${OrnamentDotted})`,
                            backgroundRepeat: 'repeat-x',
                            backgroundSize: 'auto 100%',
                            backgroundPosition: 'center',
                        }}
                    />
                    <div className="relative z-20 flex justify-center items-center py-7 md:py-8">
                        <img
                            src={TextPricingTitle}
                            alt=""
                            className="w-[420px] md:w-[800px] h-auto object-contain"
                        />
                    </div>
                </div>
                <div id="pricing-content-section" className="relative w-full flex flex-col md:flex-row pt-4 md:pt-8 justify-center items-center">
                    {/* <img
                        src={PricingCard5k}
                        alt=""
                        className="w-[320px] md:w-[420px] h-auto object-contain"
                    />
                    <img
                        src={PricingCard10k}
                        alt=""
                        className="w-[320px] md:w-[420px] h-auto object-contain"
                    /> */}
                    <div className="relative z-20 flex flex-col justify-center items-center py-8 md:basis-1/2" id="kostrad-run-content-section-left">
                        <div className="flex items-center justify-center gap-2 p-8 pb-6 pt-2">
                            <div className="flex flex-wrap items-center justify-center">
                                <img
                                    src={Text5kKategori}
                                    alt=""
                                    className="w-[160px] md:w-[240px] h-auto object-contain"
                                />
                                <img
                                    src={Text5kUmumPelajar}
                                    alt=""
                                    className="w-[160px] md:w-[240px] h-auto object-contain"
                                />
                            </div>
                            <div className="flex flex-wrap items-center justify-center">
                                <img
                                    src={Text10kKategori}
                                    alt=""
                                    className="w-[160px] md:w-[240px] h-auto object-contain"
                                />
                                <img
                                    src={Text10kUmumTniPolri}
                                    alt=""
                                    className="w-[160px] md:w-[240px] h-auto object-contain"
                                />
                            </div>
                        </div>
                    </div>
                </div>
                <div id="pricing-content-section" className="relative w-full flex flex-col md:flex-row md:mt-8 justify-center items-center bg-[#dae8d4]/80">
                    {/* <img
                        src={PricingCard5k}
                        alt=""
                        className="w-[320px] md:w-[420px] h-auto object-contain"
                    />
                    <img
                        src={PricingCard10k}
                        alt=""
                        className="w-[320px] md:w-[420px] h-auto object-contain"
                    /> */}
                    <div className="relative z-20 w-full max-w-6xl py-6 md:py-10 px-6" id="kostrad-run-content-section-bottom">
                        <div className="flex flex-col items-center gap-8">
                            <div className="flex items-center justify-center">
                                <h2 className="font-notoSans font-bold text-xl">SPONSORED BY</h2>
                            </div>
                            <div className="flex w-full flex-wrap items-center justify-center gap-x-8 gap-y-8 md:gap-y-10">
                                {sponsors.map((sponsor) => (
                                    <div
                                        key={sponsor.name}
                                        className="flex h-16 basis-[calc(50%-1rem)] shrink-0 items-center justify-center md:h-20 md:basis-[calc(33.333%-1.334rem)] lg:basis-[calc(20%-1.6rem)]"
                                    >
                                        <img
                                            src={sponsor.logo}
                                            alt={`${sponsor.name} logo`}
                                            className="max-h-full max-w-full object-contain"
                                        />
                                    </div>
                                ))}
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
}
